import {
  BASE_SLIDER_OPTIONS,
  FULL_REVIEW_SLIDER_OPTIONS,
} from '@src/quince-components/src/atoms/reviews/createReview/constants/constant'
import Product from '@src/quince-site-common/src/domains/Product'
import Bundle, { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import { SummaryReviewOption } from '@src/quince-site-common/src/domains/ProductReview'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'

export const getValidSummaryReviewOptions = (
  product: Product | Bundle,
  reviewOptions: SummaryReviewOption[] = [],
  showLargeReviewForm: boolean,
): SummaryReviewOption[] => {
  if (showLargeReviewForm || productHelper.shouldShowFullReview(product)) {
    return reviewOptions.filter(
      ro => !!FULL_REVIEW_SLIDER_OPTIONS.find(op => op.toLowerCase() === ro.name.toLowerCase()),
    )
  } else {
    return reviewOptions.filter(ro => !!BASE_SLIDER_OPTIONS.find(op => op.toLowerCase() === ro.name.toLowerCase()))
  }
}

const getChildProductIds = (product: Product, childShopifyProductIds: number[] | undefined) => {
  if (!childShopifyProductIds?.length) return []
  const childIdsSet = new Set<number>()
  childShopifyProductIds.forEach(childShopifyProductId => {
    const childVariant = product.variants.find(item => item.shopifyProductId === childShopifyProductId)
    if (childVariant?.productId) childIdsSet.add(childVariant.productId)
  })
  return Array.from(childIdsSet)
}

export const getMergeProductShopifyIds = (product: Product) => {
  const isReviewMergeNewConfig = product.addOnProductOptionGroups?.some(optionGroup => optionGroup.isReviewMerged)
  if (product.addOnProductOptionGroups && isReviewMergeNewConfig) {
    const allMergeProductIds = product.addOnProductOptionGroups.flatMap(optionGroup =>
      optionGroup.groupItems.map(groupItem => groupItem.productId),
    )
    // Getting unique IDs (main product id is in option groups as well)
    return Array.from(new Set(allMergeProductIds))
  }

  const childProductIds = getChildProductIds(product, product.childShopifyProductIds)
  return [product.id, ...(childProductIds || [])]
}

export const getReviewProductIds = (product: Product | Bundle) => {
  if (product.type !== PRODUCT_TYPES.BUNDLE) return getMergeProductShopifyIds(product)
  return product.customBundleProducts?.map(p => p.id) || []
}
